import { AABBModel } from './AABBModel';

export enum BonusTypeEnum {
    none = 'none',
    clock = 'clock',
    tea = 'tea',
    eraser = 'eraser',
    transform = 'transform',
    calculator = 'calculator',
    teleport = 'teleport',
    logo = 'logo',
    money = 'money',
}

export class BonusModel extends AABBModel {
    public active: boolean = false;
    public visible: boolean = false;
    public isCatch: boolean = false;
    public key: string = '';
    public roomIndex: number = 0;

    public constructor(public type: BonusTypeEnum) {
        super();

        this.padding = [-50, 0];
        this.height = 200;
        this.width = 200;
    }
}
